






import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { parseJwt } from "@/auth";

@Component({
  components: {}
})
export default class LearnerIndex extends Vue {
  @Getter private displayError?: any;
  @Action private setJWT: any;
  @Action private setUID: any;
  @Action private setDisplayError: any;

  private JWT!: string;
  private setJWTUID(jwt: string) {
    const mydata = parseJwt(jwt);
    this.setJWT(jwt);
    this.setUID(mydata.uid);
  }
  private created() {
    this.JWT = this.$cookies.get("ORAI_AUTH");
    if ((this.$route.name === 'reviewedSession' || this.$route.name === 'feedback') && this.$route.query.token) {
      return;
    }

    if (!this.JWT) {
      this.$router.push({
        name: "login",
        query: {
          redirect: (window.location.pathname + location.search).substr(1)
        }
      });
      return;
    } else {
      this.setJWTUID(this.JWT);
    }
  }

  @Watch("displayError")
  private onDisplayError() {
    if (this.displayError && this.displayError !== null) {
      this.$bvToast.toast(this.displayError, {
        title: "Error",
        variant: "danger",
        solid: true
      });
      this.setDisplayError(null);
    }
  }
}
